import { render, staticRenderFns } from "./basicForm.vue?vue&type=template&id=24b276ff&scoped=true"
import script from "./basicForm.vue?vue&type=script&lang=js"
export * from "./basicForm.vue?vue&type=script&lang=js"
import style0 from "./basicForm.vue?vue&type=style&index=0&id=24b276ff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b276ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b276ff')) {
      api.createRecord('24b276ff', component.options)
    } else {
      api.reload('24b276ff', component.options)
    }
    module.hot.accept("./basicForm.vue?vue&type=template&id=24b276ff&scoped=true", function () {
      api.rerender('24b276ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/costBreakdown/basicForm.vue"
export default component.exports